import {gql} from '@apollo/client'

export const GET_TEXT_MESSAGES = gql`
  query GetTextMessages($q: String, $page: Int, $limit: Int) {
    textMessages(q: $q, page: $page, limit: $limit) {
      collection {
        id
        contentWithPlaceholders
        sender
        recipients {
          id
          content
          e164MobileNumber
          status
          account {
            id
            displayName @client
            contactFullName @client
            name
            contactFirstName
            contactLastName
          }
        }
        createdAt
      }
      metadata {
        totalCount
      }
    }
  }
`
